import React from 'react';
import { CornerBrackets, FadeIn } from '../ui';
export function Testimonials() {
  const testimonials = [{
    quote: "From the start, Atrium's professionalism and transparency made our building journey a seamless experience. I cannot thank our building supervisor Vic Tosi and his team enough for their outstanding service, communication and workmanship. Would highly recommend Atrium Homes.",
    author: 'Alia & Daniel'
  }, {
    quote: 'This is our second Atrium home. We found everyone involved helpful and easy to deal with. We love our home. If we were to build again we would certainly build with Atrium.',
    author: 'Mark & Vanessa'
  }, {
    quote: 'Superb construction, great sales, amazing design, skilful details and a high-quality home. We could not have built our beautiful home with any other builder than Atrium Homes.',
    author: 'Peter'
  }];
  return <section className="py-16 md:py-24 bg-atrium-ivory" data-id="element-331">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-332">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-333">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 100} data-id="element-334">
              <div className="relative h-full p-8 md:p-10 bg-white shadow-diffuse flex flex-col justify-between" data-id="element-335">
                <CornerBrackets color="bronze" data-id="element-336" />
                <blockquote className="mb-8" data-id="element-337">
                  <p className="text-base md:text-lg font-serif text-atrium-ink leading-relaxed" data-id="element-338">
                    "{testimonial.quote}"
                  </p>
                </blockquote>
                <div className="flex items-center gap-4" data-id="element-339">
                  <div className="w-8 h-[1px] bg-atrium-bronze" data-id="element-340" />
                  <span className="text-xs font-bold tracking-wider text-atrium-ink uppercase" data-id="element-341">
                    {testimonial.author}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}